"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.whatsapp.group': 'WhatsApp 群组',
    'route.whatsapp.group.create': '添加 WhatsApp 群组',
    'route.whatsapp.dm': 'WhatsApp私信联系人',
};
